import { css, html, LitElement } from "lit"

export default class PageListeMessages extends LitElement {
  static properties = { listeConversations: { type: Array, state: true } }

  static styles = css`
    ul {
      list-style-type: none;
      display: flex;
      flex-direction: column;
      gap: 15px;
      padding: 0;
    }

    a {
      text-decoration: none;
      color: inherit;
      display: block;
      padding: 10px;
      border-radius: 8px;
      transition: background-color 0.3s;
    }

    .nomParticipant {
      font-weight: bold;
      font-size: 1.2em;
    }
    .dateMessage {
      color: gray;
      font-size: 0.9em;
    }
    .dernierMessage {
      margin-top: 0.5em;
    }`

  constructor() {
    super()
    this.listeConversations = []
  }

  async connectedCallback() {
    super.connectedCallback()
    this.listeConversations = await this.recupererListeConversations()
  }

  async recupererListeConversations() {
    const conversations = await window.authentification.bdd.conversation.recupererToutesLesConversationsDuMembreConnecte()
    const idMembreConnecte = window.authentification.getUser().uid

    return await Promise.all(
      conversations.map(async (conversation) => {
        const idAutreParticipant = conversation.participants?.find((idParticipant) => idParticipant !== idMembreConnecte)

        if (!idAutreParticipant) {
          return { ...conversation, pseudoAutreParticipant: "Participant inconnu" }
        }

        const pseudoAutreParticipant = await window.authentification.bdd.membres.recupererLePseudoDunMembre(idAutreParticipant)
        return { ...conversation, pseudoAutreParticipant }
      }),
    )
  }

  render() {
    return html`
            <h1>Liste des conversations</h1>
            ${this.genererListeConversations()}
        `
  }

  genererListeConversations() {
    if (this.listeConversations.length === 0) {
      return html`<p>Aucune conversation pour le moment. Commencez par aller voir ce que les membres proposent comme pokémon à l'échange pour leur envoyer un message !</p>`
    }
    return html`<ul>
                ${this.listeConversations.map(
                  (conversation) => html`<li>
        <a href="/conversations/${conversation.id}">
          <div><span class="nomParticipant">${conversation.pseudoAutreParticipant}</span> <span class="dateMessage">${this.formaterDate(conversation.dateDernierMessage)}</span></div>
          <div class="dernierMessage">${conversation.dernierMessage}</div>
        </a>
      </li>`,
                )}
            </ul>`
  }

  formaterDate(date) {
    if (!date) {
      return "À l'instant"
    }

    /** @type {Intl.DateTimeFormatOptions} */
    const options = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }
    const dateJs = date?.toDate?.() ?? date
    return new Date(dateJs).toLocaleDateString("fr-FR", options)
  }
}
customElements.define("p-page-liste-messages", PageListeMessages)
